import React from "react";
import UploadPage from "./UploadPage";
import GenerateLinkPage from "./GenerateLinkPage";
import ViewerPage from "./ViewerPage";

function App() {
  const path = window.location.pathname;
  if (path.includes("/upload")) return <UploadPage />;
  if (path.includes("/generate")) return <GenerateLinkPage />;
  if (path.includes("/view")) return <ViewerPage />;

  return (
    <div style={{ padding: 20 }}>
      <h2>Photo Selection App</h2>
      <p>Choose an action:</p>
      <a href="/upload"><button>Upload Photos</button></a>
      <a href="/generate" style={{ marginLeft: 10 }}><button>Generate Link</button></a>
      <p style={{ marginTop: 20 }}>To view photos, open the generated link with <code>?token=...</code></p>
    </div>
  );
}

export default App;
